import { requiredFieldsByStage } from 'components/Cases/CaseFormStep/CaseFormStep.helper';
import { createEmptyAction } from 'components/Cases/hooks/useDiagnosisForm';
import dayjs from 'dayjs';
import { caseStatus, DiagnosisFormWithAsset } from 'queries/cases/types';
import { UseFormGetValues, FieldValues, UseFieldArrayReturn } from 'react-hook-form';

export const isDiagnosisFilled = (getValues: UseFormGetValues<FieldValues>) =>
  [...requiredFieldsByStage[caseStatus.diagnosis], 'discipline', 'asset.name', 'name'].every(
    (field) => {
      const value = getValues(field as keyof DiagnosisFormWithAsset);
      if (field === 'name') {
        return value !== null && value !== undefined && value.trim() !== '';
      }

      return value !== '' && value !== null && value !== undefined;
    },
  );

export const createNewAction = (fieldArray: UseFieldArrayReturn<FieldValues, 'actions', 'id'>) => {
  fieldArray.prepend({
    ...createEmptyAction(),
    creation_date: dayjs().utc().format(),
  });
};
